import { render, staticRenderFns } from "./SettingsSolid.vue?vue&type=template&id=375ce213&"
import script from "./SettingsSolid.vue?vue&type=script&lang=ts&"
export * from "./SettingsSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports